export default __webpack_public_path__ + "static/201-fb8749b171a581b522aac94ff539b82c.gif";